<script setup>
import router from '../../routes/index';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    class="bb-voltar flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="buttonStyleClass"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1 text-lg" />
    {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
  </button>
</template>

<style scoped>
/* ── Celular ─────────────────────────────────────────────────────────────────
   No celular este é o caminho de VOLTA da conversa para a lista — a ação mais
   usada da tela. Medido em 08/09/2026: 74x24, abaixo dos 32px que o padrão
   exige para toque (regra 2.5). A área cresce por ::after, sem mexer no
   alinhamento do cabeçalho. */
@media (max-width: 639px) {
  .bb-voltar {
    position: relative;
  }

  .bb-voltar::after {
    content: '';
    position: absolute;
    inset: -8px -10px;
  }
}
</style>
